export default __webpack_public_path__ + "static/media/logomarca-commercial-edition1.df0e33df.png";